import { render, staticRenderFns } from "./documentPOAI.vue?vue&type=template&id=4a95e700&scoped=true"
import script from "./documentPOAI.vue?vue&type=script&lang=js"
export * from "./documentPOAI.vue?vue&type=script&lang=js"
import style0 from "./documentPOAI.vue?vue&type=style&index=0&id=4a95e700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a95e700",
  null
  
)

export default component.exports